import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../components/card/card";
import ImageViewer from "../../components/ImageViewer";
import { printDate, printLocation } from "../../utils/helper";
import React, { useState, useEffect } from "react";
import { notification, userRole } from "../../api";
import { parserAPI } from "../../utils/parser";
import { formatDateFull } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ConfirmationDlg from "../../components/ConfirmationDlg";

function NotificationLogs() {
  const [userRoles, setUserRoles] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [location_wording, setLocation_wording] = useState([]);
  const [data, setData] = useState([]);

  async function GetRoles() {
    try {
      const res = await notification.listNotifThreshold();
      const datas = await parserAPI(res);
      setData(datas);
    } catch (e) {
      console.error(e);
    }
  }
  useEffect(() => {
    GetRoles();
  }, []);
  async function deleteUserRoleConfirm(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  async function deleteUserRole() {
    try {
      const response = await userRole.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          toast.success("This role has been deleted");
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        GetRoles();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function addUserRole(value) {
    setOpenDetail(true);
  }
  function editUserRole(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  const columns = [
    {
      name: "Date",
      width: "200px",
      selector: (row) => formatDateFull(row.created_at),
    },
    {
      name: "Machine",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.description.split("|")[0]}</span>;
      },
    },
    {
      name: "Location",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.description.split("|")[1]}</span>;
      },
    },
    {
      name: "Alert",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.notif_type}</span>;
      },
    },
  ];
  async function onSubmit({ name, userRoleFeatureAccess, accesses, status }) {
    let data = {
      rolename: name,
      accesses,
      feature_accesses: userRoleFeatureAccess.map((fa) => ({
        page_name: fa.name,
        ...fa,
        name: undefined,
      })),
      //is_active: status == "1" ? true : false,
    };

    if (!selectedRow) {
      const response = await userRole.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await userRole.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    GetRoles();
  }

  return (
    <div>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUserRole}
      >
        <div>Are you sure you want to delete this role?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Notification</a>
            </li>
          </ol>
          <h1 className="page-header mb-0">Notification Logs</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <Card className="mb-4 mt-2">
            <CardHeader>Update Role</CardHeader>
            <CardBody>
              <DataTable
                highlightOnHover
                theme="dark"
                columns={columns}
                data={data}
                pagination
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default NotificationLogs;
